module.exports = __webpack_public_path__ + "img/card-configuration-services-and-cost-hover.cc48622f.svg";